var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99967 4.35139C6.42449 4.35139 6.76887 4.00701 6.76887 3.58219C6.76887 3.15737 6.42449 2.81299 5.99967 2.81299C5.57485 2.81299 5.23047 3.15737 5.23047 3.58219C5.23047 4.00701 5.57485 4.35139 5.99967 4.35139Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73047 5.41296H6.23047C6.36857 5.41296 6.48047 5.52486 6.48047 5.66296V8.93636C6.48047 9.07446 6.36857 9.18636 6.23047 9.18636H5.73047C5.59237 9.18636 5.48047 9.07446 5.48047 8.93636V5.66296C5.48047 5.52486 5.59237 5.41296 5.73047 5.41296Z",
    fill: "#606060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11.5C2.9678 11.5 0.5 9.0322 0.5 6C0.5 2.9678 2.9678 0.5 6 0.5C9.0322 0.5 11.5 2.9678 11.5 6C11.5 9.0322 9.0322 11.5 6 11.5ZM6 1.5C3.5186 1.5 1.5 3.5186 1.5 6C1.5 8.4814 3.5186 10.5 6 10.5C8.4814 10.5 10.5 8.4814 10.5 6C10.5 3.5186 8.4814 1.5 6 1.5Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.6e3438ab3477118d3bd14553a6a7adfc.svg";
export { ForwardRef as ReactComponent };